import { atom, useSetRecoilState } from 'recoil';
import { getPseudoRandomId } from '../../shared/id';
import { KIND } from 'baseui/notification';

interface Notification {
    text: string;
    kind?: keyof KIND;
    closeable?: boolean;
    timeoutInMs?: number;
    id?: number;
}

export const appNotifications = atom<Array<Notification>>({
    key: 'notifications',
    default: [],
});

export const useAppNotifications = () => {
    const setNotifications = useSetRecoilState(appNotifications);

    const pushNotification = ({
        text,
        kind = KIND.positive,
        closeable = true,
        timeoutInMs = 8000,
    }: Notification) => {
        const id = getPseudoRandomId();

        setTimeout(() => {
            setNotifications((oldArr) => {
                return oldArr.filter((notification) => notification.id !== id);
            });
        }, timeoutInMs);

        setNotifications((oldArr) => {
            return [
                ...oldArr,
                {
                    text,
                    kind,
                    closeable,
                    id,
                },
            ];
        });
    };

    return {
        pushNotification,
    };
};
